var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('h3',[_vm._v("Product List")]),_c('b-container',{staticClass:"m-0 p-0"},[_c('b-row',_vm._l((_vm.products),function(product){return _c('b-col',{key:product.id,staticClass:"mb-3",attrs:{"cols":"12","md":"6"}},[_c('product-item',{attrs:{"product":product}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }